module.exports = __webpack_public_path__ + "img/desk3.6bfb43b2.png";